/* Pengurusan token JWT: satu sumber kebenaran.

   Modul ini sengaja berasingan daripada api.js dan auth.js kerana kedua-duanya
   memerlukannya, dan auth.js sudah mengimport api.js. Meletakkannya di sini
   mengelakkan kebergantungan pusingan (circular dependency).

   Nota keselamatan yang jujur:
   - Token disimpan dalam localStorage kerana backend mengesahkan melalui header
     `Authorization: Bearer`.
   - Beralih kepada sessionStorage TIDAK meningkatkan keselamatan terhadap XSS.
     Kedua-duanya boleh dibaca oleh skrip dalam halaman yang sama; ia hanya
     memaksa log masuk semula pada setiap tab baharu.
   - Perlindungan XSS yang betul ialah kuki httpOnly + SameSite, tetapi itu
     memerlukan perubahan backend (Set-Cookie) serta perlindungan CSRF.
     Dicatat sebagai kerja akan datang, bukan tampalan sebelah frontend.

   Pengukuhan yang dilaksanakan di sini:
   1. Token luput dibuang serta-merta, jadi token mati tidak pernah dihantar.
   2. Token rosak atau bukan JWT dibuang, bukan disimpan selama-lamanya. */

export const KUNCI_TOKEN = "pr_token";

/** Baca muatan JWT tanpa mengesahkan tandatangan. Pengesahan sebenar sentiasa
    dilakukan oleh backend; ini hanya untuk semakan luput di pihak pelanggan. */
const muatanToken = (t) => {
  try {
    const bhg = String(t).split(".");
    if (bhg.length !== 3) return null;
    return JSON.parse(atob(bhg[1].replace(/-/g, "+").replace(/_/g, "/")));
  } catch (e) {
    // Token bukan JWT yang sah. Dianggap tidak boleh digunakan.
    return null;
  }
};

export const tokenLuput = (t) => {
  const p = muatanToken(t);
  if (!p || typeof p.exp !== "number") return true;
  // Tolak 10 saat untuk mengelak perlumbaan dengan jam pelayan.
  return p.exp * 1000 <= Date.now() + 10000;
};

export const getToken = () => {
  const t = localStorage.getItem(KUNCI_TOKEN) || "";
  if (!t) return "";
  if (tokenLuput(t)) {
    localStorage.removeItem(KUNCI_TOKEN);
    return "";
  }
  return t;
};

export const setToken = (t) => localStorage.setItem(KUNCI_TOKEN, t);

export const clearToken = () => localStorage.removeItem(KUNCI_TOKEN);
